import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TokenService } from 'src/app/services/token/token.service';

@Component({
  selector: 'app-store-selection',
  templateUrl: './store-selection.component.html',
  styleUrls: ['./store-selection.component.scss']
})
export class StoreSelectionComponent implements OnInit, OnDestroy {
  @Output() readonly selectStore = new EventEmitter<any>();
  stores: any[] = [];
  readonly storeInputCtrl = new UntypedFormControl('');
  private subscription: Subscription;

  constructor(
    private tokenServe: TokenService
  ) {
    this.subscription = this.storeInputCtrl.valueChanges.subscribe((value: string) => {
      const selectedStore = this.stores.find(b => b.id === value);
      this.selectStore.emit(selectedStore);
    });
  }

  ngOnInit(): void {
    this.stores = this.tokenServe.getStores();
    this.storeInputCtrl.setValue(this.stores[0]?.id);
    // console.log(this.stores, 'list');
    this.selectStore.emit(this.stores[0]);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
